import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {PatternAnalysisRequest, PatternAnalysisResponse} from "../../model/dto/api/ai-segment-suggestion.interface";
import {AiCampaignPatternAnalysisDto} from "../../model/dto/entity/ai-campaign-pattern-analysis.dto";

/**
 * Service for AI campaign pattern analysis.
 * F-024: AI-Powered Segment Suggestions - Acceptance Criteria: Given historical campaign data,
 * when analyzed, then AI identifies patterns in successful segments.
 */
@Injectable({
    providedIn: 'root'
})
export class AiCampaignPatternAnalysisService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/aiPatternAnalyses')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-chart-line';
    }

    /**
     * Starts a pattern analysis on historical campaigns.
     * F-024: Acceptance Criteria - "Given historical campaign data, when analyzed,
     * then AI identifies patterns in successful segments"
     */
    startPatternAnalysis(request: PatternAnalysisRequest): Observable<PatternAnalysisResponse> {
        return this.postGeneric<PatternAnalysisResponse>(request, '/analyze');
    }

    /**
     * Gets analysis details by ID.
     */
    getAnalysisDetails(analysisId: number): Observable<AiCampaignPatternAnalysisDto> {
        return this.getGeneric<AiCampaignPatternAnalysisDto>(`/${analysisId}/details`);
    }

    /**
     * Gets recent analyses for a user.
     */
    getRecentAnalysesForUser(userId: number): Observable<AiCampaignPatternAnalysisDto[]> {
        return this.getGeneric<AiCampaignPatternAnalysisDto[]>(`/user/${userId}/recent`);
    }

    /**
     * Gets completed analyses.
     */
    getCompletedAnalyses(): Observable<AiCampaignPatternAnalysisDto[]> {
        return this.getGeneric<AiCampaignPatternAnalysisDto[]>('/completed');
    }

    /**
     * Gets active (running) analyses.
     */
    getActiveAnalyses(): Observable<AiCampaignPatternAnalysisDto[]> {
        return this.getGeneric<AiCampaignPatternAnalysisDto[]>('/active');
    }
}
